import { HttpClient, HttpParams} from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { Vacaciones } from '../models/vacaciones.model';
import { PeriodosVacacionesModel } from '../models/periodosVacaciones.model';
import { A3LEmployeeAbsenteeismSummary } from '../models/a3LEmployeeAbsenteeismSummary.model';
import { DatosDiasVacacionesKpiModel } from '../models/datosDiasVacacionesKpi.model';

@Injectable()
export class VacacionesService extends HttpClientBaseService implements IServiceBase<Vacaciones> {
  constructor(_http: HttpClient) {
    super(_http, 'holidays/','', false);
  }
  getAllModels(parentId?: any, params?: HttpParams): Observable<Vacaciones[]> {
    return super.getAll<Vacaciones[]>();
  }
  getAllByCompanyAndYear(companyCode: number, year: number): Observable<Vacaciones[]> {
    return this.http.get<Vacaciones[]>(`${super.getUrl()}company/${companyCode}/year/${year}`);
  }

  getPeriodsByCompanyAndYear(companyCode: number, year: number): Observable<PeriodosVacacionesModel[]> {
    return this.http.get<PeriodosVacacionesModel[]>(`${super.getUrl()}company/${companyCode}/year/${year}/periods`);
  }

  getKpiDataByCompanyAndYear(companyCode: number, year: number): Observable<DatosDiasVacacionesKpiModel> {
    return this.http.get<DatosDiasVacacionesKpiModel>(`${super.getUrl()}company/${companyCode}/year/${year}/kpiData`);
  }

  getAllByCompanyEmployeeAndYear(companyCode: number, employeeCode: string, year: number): Observable<Vacaciones> {
    return this.http.get<Vacaciones>(`${super.getUrl()}company/${companyCode}/employee/${employeeCode}/year/${year}`);
  }

  actualizarAjuste(companyCode: string, employeeCode: string, year: number, days: number): Observable<A3LEmployeeAbsenteeismSummary>{
    return this.http.put<A3LEmployeeAbsenteeismSummary>(`${super.getUrl()}company/${companyCode}/employee/${employeeCode}/year/${year}/ajuste/${days}`, null)
  }

  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<Vacaciones>> {
    throw new Error('Method not implemented.');
  }

  getModel(id: any, parentId?: any): Observable<Vacaciones> {
    return super.getSingle<Vacaciones>(id);
  }
}
